import { render, staticRenderFns } from "./HeaderCardsES.vue?vue&type=template&id=109ec2d1&lang=pug"
import script from "./HeaderCardsES.vue?vue&type=script&lang=ts"
export * from "./HeaderCardsES.vue?vue&type=script&lang=ts"
import style0 from "./HeaderCardsES.vue?vue&type=style&index=0&id=109ec2d1&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryCard: require('/app/components/parts/CategoryCard.vue').default})
